import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import SmallModalContainer from '../../common/SmallModalContainer';
import {
  CONSULTORIO_CONNECTION_BLOCKING_COPY,
  CONSULTORIO_CONNECTION_BLOCKING_REASON
} from '../../../utils/Constants/consultorioConnectionBlocking';
import iconError from '../../../assets/icons/icon_circle-error.svg';

function ModalConsultorioConnectionBlocked({ open, onClose, blockingReason }) {
  const copy =
    CONSULTORIO_CONNECTION_BLOCKING_COPY[blockingReason] ||
    CONSULTORIO_CONNECTION_BLOCKING_COPY[CONSULTORIO_CONNECTION_BLOCKING_REASON.CONSULTORIO_DIGITAL];

  return (
    <SmallModalContainer open={open} onClose={onClose}>
      <Box display="flex" flexDirection="column" gap={'1rem'}>
        <Box
          component="img"
          sx={{ width: '54px', height: '54px' }}
          alt=""
          src={iconError}
        />
        <Typography variant="h1">{copy.modalTitle}</Typography>
        <Typography variant="h4" component="p">
          {copy.modalLead}
        </Typography>
        {copy.modalHint ? (
          <Typography variant="h5" component="p">
            {copy.modalHint}
          </Typography>
        ) : null}
        <Box display="flex" gap={'1rem'} marginTop="1.5rem">
          <Button
            onClick={onClose}
            variant="contained"
            sx={{ height: '48px', borderRadius: '16px', width: '100%' }}>
            <Typography variant="tabs" component="span">
              Entendido
            </Typography>
          </Button>
        </Box>
      </Box>
    </SmallModalContainer>
  );
}

export default ModalConsultorioConnectionBlocked;
